import { render } from "./ModelMetricsDocked.vue?vue&type=template&id=57efddf2&scoped=true"
import script from "./ModelMetricsDocked.vue?vue&type=script&lang=js"
export * from "./ModelMetricsDocked.vue?vue&type=script&lang=js"

import "./ModelMetricsDocked.vue?vue&type=style&index=0&id=57efddf2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57efddf2"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
